import { T as f } from "./Text-C0Ywl2OH.js";
export {
  f as default
};
